import { type ErrorMessageParams, AuthActionTypes } from "../../useAuthenticateReducer";

import { sanitizeURL } from "../../../../utils/stringUtils";

export enum ErrorCode {
    ALTERNATE_LOGIN = "alternative.error.login",
    HARDSTOP = "logon.accu.hardstop",
    INCORRECT = "error.passcode.incorrect"
}

interface Error {
    attempts?: string;
    code: string;
    errors: Omit<ErrorMessageParams, "errorCode">[];
    message: string;
    status: string;
}

export interface ErrorResponse {
    data: null;
    error: Error;
    status: string;
}

interface AuthenticationState {
    errorCode?: string;
    errorMessage?: string;
    errorMessageParams?: ErrorMessageParams;
    processing?: "failed" | "pending" | "loginsuccess" | "";
}

interface AuthenticateFailuresArgs {
    dispatch: ({ type, payload }: { payload?: AuthenticationState; type: string }) => void;
    error: ErrorResponse;
    loginDomain: string;
    setLoggingInState: (loading: boolean) => void;
    setShowLogin: (showLogin: boolean) => void;
}

const onAuthenticateFailure = ({
    error,
    dispatch,
    setLoggingInState,
    setShowLogin,
    loginDomain
}: AuthenticateFailuresArgs): string | null => {
    dispatch({ type: AuthActionTypes.FAILED_AUTHENTICATION });

    if (error.status == "FAIL") {
        let errorCode = error.error.code;

        const payload: AuthenticationState = {
            errorMessage: errorCode,
            errorCode
        };

        dispatch({
            type: AuthActionTypes.SET_AUTHENTICATION_ERROR_CODE,
            payload
        });

        setLoggingInState(false);

        if (error.error.errors !== null) {
            const errorMessageParamsPayload = error.error.errors[0];

            dispatch({
                type: AuthActionTypes.SET_AUTHENTICATION_ERROR_MESSAGE_PARAMS,
                payload: { errorMessageParams: errorMessageParamsPayload }
            });

            if (errorMessageParamsPayload.code === ErrorCode.HARDSTOP) {
                return loginDomain + "/registration/regError";
            }

            if (
                errorMessageParamsPayload.code === ErrorCode.INCORRECT &&
                errorMessageParamsPayload.attempts === "1"
            ) {
                errorCode = "error.passcode.incorrect.redirect.help";
                // noScope to indicate this is coming from iframe nad RegistrationController and other
                // angular can see this is redirecting with no scope.
                const errorCodeParam = errorCode.replaceAll(".", "-");
                const redirectData = {
                    destinationUrl: `/participant/#/loginHelp?errorMessage=true&attempts=done&noScope=true&count=${errorMessageParamsPayload.attempts}&errorCodeParam=${errorCodeParam}`,
                    from: "LOGIN_ERROR"
                };
                setShowLogin(false);
                return loginDomain + redirectData.destinationUrl;
            }
            if (errorCode === ErrorCode.ALTERNATE_LOGIN) {
                const redirectUrl = sanitizeURL(errorMessageParamsPayload.ALTERNATIVE_LOGN_URL);
                return redirectUrl;
            }
        }
    }

    return null;
};

export default onAuthenticateFailure;
